import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10125a73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "watch_status_notice" }
const _hoisted_2 = { class: "watch_status_notice_text" }
const _hoisted_3 = { class: "error_icon" }
const _hoisted_4 = { class: "watch_status_button" }

import Icon from '@/components/atoms/Icon'
import IconButton from '@/components/molecules/IconButton'
import { GetCamerasDataWatch } from '@/@types/typescript-axios'


type PropsType = {
  cameraStatus: GetCamerasDataWatch
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WatchStatusNotice',
  props: {
    cameraStatus: null
  },
  emits: ["updateDownQuery"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_unref(Icon), {
          type: "error_outline",
          color: "color-red"
        })
      ]),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('cameras.failed_cameras', {
          downCameraCount: __props.cameraStatus.down,
          downLocationCount: __props.cameraStatus.downLocation,
        })), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(IconButton), {
        icon: "filter_list",
        "use-border": true,
        "use-circle": true,
        "icon-color": "color-dark2",
        "border-color": "color-dark2",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('updateDownQuery', 'down')))
      })
    ])
  ]))
}
}

})